import React from 'react';

import { FormikErrors } from 'formik';
import { Message } from 'semantic-ui-react';
import { compact, isEmpty } from 'lodash-es';

type Props = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  errors: FormikErrors<any>;
};

export const FormikErrorsMessage = ({ errors }: Props) => {
  if (isEmpty(errors)) {
    return null;
  }

  return (
    <Message error size="small">
      <ul style={{ paddingLeft: 10 }}>
        <FormikErrorMessageItem errors={errors} />
      </ul>
    </Message>
  );
};

const FormikErrorMessageItem = ({ errors }: Props) => {
  if (typeof errors === 'string') {
    return <li>{errors}</li>;
  }
  if ('value' in errors) {
    return <li>{errors.value?.toString()}</li>;
  }
  if (typeof errors !== 'object') {
    return null;
  }

  return Object.values(errors).map((error) => {
    if (error) {
      if (Array.isArray(error)) {
        return compact(
          error.map((e) => {
            if (!e) {
              return null;
            }

            return (
              <FormikErrorMessageItem
                key={e.toString()}
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                errors={e as FormikErrors<any>}
              />
            );
          })
        );
      }
      if (typeof error === 'object') {
        return (
          <FormikErrorMessageItem
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            errors={error as FormikErrors<any>}
          />
        );
      }

      if (typeof error === 'string') {
        return <li key={error}>{error}</li>;
      }
    }
    return null;
  });
};
